// 移植自 crm/src/components/FormField.jsx。共用表單欄位外框（Figma FormField/Big/37px）。
// 狀態：Default 灰框／Active（下拉開啟或輸入 focus）藍框／Error 紅框＋下方紅字／Disabled 實色灰。
// props：label、active、error（訊息字串）、disabled、className（fieldset 額外 class）、legendClassName（預設灰字）、children
export function FormField({ label, active, error, disabled, className = '', legendClassName, children }) {
  const stateClass = error
    ? 'border-error'
    : active
      ? 'border-brand-blue-dark-2'
      : disabled
        ? 'border-brand-black-100 bg-brand-black-0'
        : // 灰框用 brand token 而非 daisyUI base-300：常用在 Portal 到 body 的 Dialog 裡，base-300 會退回預設主題色
          'border-brand-black-100 hover:border-brand-blue-dark-2 focus-within:border-brand-blue-dark-2'

  return (
    <div>
      {/* min-w-0：fieldset 天生 min-width:min-content，超長內容會撐爆彈窗，歸零後內層 truncate 才生效 */}
      <fieldset className={`min-w-0 rounded-brand-base border px-3.25 transition-colors ${label ? 'pb-1.25' : 'flex h-8 items-center'} ${className} ${stateClass}`}>
        {/* 無 label 時不渲染空 legend（否則頂邊留一條空行），改 h-8 垂直置中（Figma「FormField/small/32px」） */}
        {label && <legend className={`px-1 text-xs font-semibold leading-4.5 tracking-[0.12px] ${legendClassName ?? 'text-brand-black-400'}`}>{label}</legend>}
        {children}
      </fieldset>
      {/* 錯誤訊息與輸入框間距 10px（Figma node 9698:73106） */}
      {error && <p className="mt-2.5 text-xs leading-4.5 tracking-[0.12px] text-error">{error}</p>}
    </div>
  )
}
